import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserCircle, Settings, LogOut, RefreshCw } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const UserMenu = ({ isDarkMode = true }) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleCacheReload = () => {
    window.location.reload(true);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!currentUser) return null;

  return (
    <div className="relative">
      <button 
        onClick={() => setUserMenuOpen(!userMenuOpen)}
        className={`flex items-center space-x-2 ${
          isDarkMode ? 'text-slate-300 hover:text-slate-100' : 'text-slate-600 hover:text-slate-800'
        }`}
      >
        <UserCircle className="w-6 h-6" />
        {currentUser && (
          <span className="hidden md:inline ml-2">{currentUser.username}</span>
        )}
      </button>

      {userMenuOpen && (
        <div className={`absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 ring-1 ring-black ring-opacity-5 border z-50
          ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
          <Link 
            to="/profile" 
            className={`block px-4 py-2 text-sm ${isDarkMode ? 'text-slate-300 hover:bg-slate-700' : 'text-slate-700 hover:bg-slate-100'} flex items-center`}
            onClick={() => setUserMenuOpen(false)}
          >
            <UserCircle className="w-4 h-4 mr-2" />
            My Profile
          </Link>
          <Link 
            to="/profile/preferences" 
            className={`block px-4 py-2 text-sm ${isDarkMode ? 'text-slate-300 hover:bg-slate-700' : 'text-slate-700 hover:bg-slate-100'} flex items-center`}
            onClick={() => setUserMenuOpen(false)}
          >
            <Settings className="w-4 h-4 mr-2" />
            Preferences
          </Link>
          <button 
            onClick={handleCacheReload} 
            className={`block w-full text-left px-4 py-2 text-sm ${isDarkMode ? 'text-slate-300 hover:bg-slate-700' : 'text-slate-700 hover:bg-slate-100'} flex items-center`}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Refresh Cache
          </button>
          <div className={`border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'} my-1`}></div>
          <button 
            onClick={handleLogout} 
            className={`block w-full text-left px-4 py-2 text-sm ${isDarkMode ? 'text-red-400 hover:bg-slate-700' : 'text-red-600 hover:bg-slate-100'} flex items-center`}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;